import { useMemo } from "react";

import { useGetTags } from "../../../api/insights";
import { RankedBarChart } from "../charts";
import SectionShell, { ChartPair } from "../SectionShell";

function InterestsTags({ eventId }) {
  const { data, isPending, isError, error } = useGetTags(eventId);

  const { categories, interests } = useMemo(() => {
    const rows = Array.isArray(data) ? data : [];
    const toRow = (r) => ({
      tag: r.title ?? "(unknown)",
      People: Number(r.userCount ?? 0),
    });
    const bySubtype = (subtype) =>
      rows
        .filter((r) => r.subtype === subtype)
        .map(toRow)
        .sort((a, b) => b.People - a.People);
    return {
      categories: bySubtype("categoryOfUser"),
      interests: bySubtype("topicOfInterest"),
    };
  }, [data]);

  return (
    <SectionShell
      id="interestsTags"
      title="Interests / tags"
      description="Distribution of attendee interest tags."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="interestsTags"
    >
      <ChartPair>
        <RankedBarChart
          part="attendeeCategories"
          title="Attendee categories"
          data={categories}
          categoryKey="tag"
          series={[{ name: "People", color: "blue.6" }]}
        />
        <RankedBarChart
          part="mostCommonInterests"
          title="Most common interests"
          data={interests}
          categoryKey="tag"
          series={[{ name: "People", color: "teal.6" }]}
        />
      </ChartPair>
    </SectionShell>
  );
}

export default InterestsTags;
